import { render, staticRenderFns } from "./MarcomVenueEdit.vue?vue&type=template&id=b5973eb2&scoped=true&"
import script from "./MarcomVenueEdit.vue?vue&type=script&lang=js&"
export * from "./MarcomVenueEdit.vue?vue&type=script&lang=js&"
import style0 from "./MarcomVenueEdit.vue?vue&type=style&index=0&id=b5973eb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5973eb2",
  null
  
)

export default component.exports